(() => {
  const fixedOrSticky = (el) => {
    let n = el;
    for (let i = 0; n && i < 9; i += 1, n = n.parentElement) {
      if (n.matches?.('header,.pmx-gh,.pmotive-ai-header')) return null;
      const s = getComputedStyle(n);
      if (s.position === 'fixed' || s.position === 'sticky') return n;
    }
    return null;
  };

  const hideRetailOverlay = (node) => {
    const target = fixedOrSticky(node) || (node.tagName === 'IFRAME' ? node : null);
    if (!target) return;
    target.style.setProperty('display', 'none', 'important');
    target.setAttribute('aria-hidden', 'true');
  };

  const clean = () => {
    document.querySelectorAll('iframe').forEach((frame) => {
      const src = (frame.getAttribute('src') || '').toLowerCase();
      if (['chizy','cwillsendwill','nova-multi-currency','nova-currency'].some((term) => src.includes(term))) hideRetailOverlay(frame);
    });

    document.querySelectorAll('button,a,span,[role="button"],div').forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 46) return;
      if (text === 'Get 10% OFF' || text === 'Get 35% OFF' || text === 'GET 10% OFF' || text === 'GET 35% OFF') hideRetailOverlay(node);
    });
  };

  const run = () => requestAnimationFrame(clean);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true }); else run();
  [300,800,1600,3200,6000].forEach((delay) => setTimeout(clean, delay));

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; clean(); });
  });
  observer.observe(document.documentElement, { childList:true, subtree:true });
  setTimeout(() => observer.disconnect(), 10000);
})();